import "@/App.css";
import { CartProvider } from "@/context/CartContext";
import { useLenis } from "@/hooks/useLenis";
import { Toaster } from "@/components/ui/sonner";
import { Nav } from "@/components/site/Nav";
import { Hero } from "@/components/site/Hero";
import { SpiceMarquee } from "@/components/site/SpiceMarquee";
import { Products } from "@/components/site/Products";
import { Manifesto } from "@/components/site/Manifesto";
import { Founder } from "@/components/site/Founder";
import { OrderSection } from "@/components/site/OrderSection";
import { Footer } from "@/components/site/Footer";
import { CartDrawer } from "@/components/site/CartDrawer";
import { CheckoutDialog } from "@/components/site/CheckoutDialog";
import { WhatsAppButton } from "@/components/site/WhatsAppButton";

function App() {
  useLenis();
  return (
    <CartProvider>
      <div className="grain relative bg-[#F9F6F0] min-h-screen">
        <Nav />
        <main>
          <Hero />
          <SpiceMarquee />
          <Products />
          <Manifesto />
          <Founder />
          <OrderSection />
        </main>
        <Footer />
        <CartDrawer />
        <CheckoutDialog />
        <WhatsAppButton />
        <Toaster position="bottom-center" />
      </div>
    </CartProvider>
  );
}

export default App;
